let isTypeItFrozen = false;

export const setIsTypeItFrozen = (value) => {
  isTypeItFrozen = value;
};

export const getIsTypeItFrozen = () => {
  return isTypeItFrozen;
};
